const sortGroupsByCreationDate = groups =>
  groups.sort((a, b) => b.createdAt.localeCompare(a.createdAt));

export default sortGroupsByCreationDate;
